import { dateFilterStyle, uiblockerStyle } from '@bingads-webui-campaign-react/common-styles';
import { ComponentSettings } from '@bingads-webui-theme-2018/theme-fluent';

const { datePickerStyle } = ComponentSettings;

const { getSharedFooterStyles } = ComponentSettings.GridSharedStyles;
export default function getStyles(_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) {
  return {
    '@global': {
      ...uiblockerStyle({ palette }),
      ...datePickerStyle({ palette, iconFontFamily }),
      '.k-list-container': {
        overflow: 'auto',
        backgroundColor: palette.white,
        width: 86,
        fontSize: 12,

        '&.k-popup': {
          border: '1px solid #e5e5e5',
          height: '100%',
        },

        '& ul': {
          listStyle: 'none',
          padding: 0,

          '& li': {
            padding: 5,
            cursor: 'pointer',
            '&:hover': {
              background: '#edebe9',
            },
          },
        },
      },
      '.bingads-campaign-react-sub-page-menu': {
        '& .compared-date-range-picker': {
          display: 'none',
        },
      },
    },
    ReconReortGridContainer: {
      marginTop: 20,
      '& .recon-grid': {
        '& table': {
          border: 0,
        },
        '& thead.header tr th.column-header': {
          borderTop: '2px solid #81868B',
          borderBottom: '2px solid #81868B',
          borderLeft: 'none',
          '&:last-child': {
            borderRight: 'none',
          },
        },
        '& tr .text-left': {
          borderLeft: 'none',
          '&:last-child': {
            borderRight: 'none',
          },
        },
        '& .pagination-row td': {
          border: 'none',
        },
      },
      '& .grid-noresult': {
        color: '#605e5c',
        padding: '20px 0 20px 40px',
        fontSize: 26,
        lineHeight: '36px',
      },
      '& .date-filter-container': {
        margin: 15,
        '& .customDateRangePanel .errors': {
          display: 'none',
        },
      },
      '& .page-size-selector': {
        display: 'inline-block',
        width: 'auto',
        verticalAlign: 'middle',
      },
      ...getSharedFooterStyles(_, { palette }),
      ...dateFilterStyle({ palette }),
    },
  };
}
